import { Globe, FileText, Palette, Settings } from 'lucide-react';

export function Services() {
  const services = [
    {
      title: "SITE WEB COMPLET",
      description: "Design personnalisé, maquettage professionnel, et développement sur mesure pour votre présence en ligne.",
      icon: Globe,
      bgColor: "bg-orange-600",
      size: "large"
    },
    {
      title: "SITE VITRINE",
      description: "Présentation efficace et percutante en une seule page pour convertir vos visiteurs.",
      icon: FileText,
      bgColor: "bg-yellow-400",
      size: "medium"
    },
    {
      title: "IDENTITÉ VISUELLE",
      description: "Création de logos, cartes de visite et flyers qui reflètent votre image de marque.",
      icon: Palette,
      bgColor: "bg-violet-600",
      textColor: "text-white",
      size: "medium"
    },
    {
      title: "MAINTENANCE & SEO",
      description: "Sécurisation continue et optimisation pour améliorer votre visibilité en ligne.",
      icon: Settings,
      bgColor: "bg-cyan-400",
      size: "small"
    }
  ];

  return (
    <section id="services" className="bg-[#F0F8FF] py-10 px-4 sm:py-16 sm:px-6 md:py-20 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-32 h-32 bg-yellow-400 rounded-full opacity-20" />
      <div className="absolute bottom-20 left-10 w-24 h-24 bg-orange-600 rounded-full opacity-20" />
      
      <div className="max-w-7xl mx-auto relative">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-black mb-3 sm:mb-4 leading-tight">
            MES SERVICES
          </h2>
          <p className="text-base sm:text-xl font-bold text-gray-700 max-w-2xl mx-auto">
            Une approche personnalisée pour transformer votre vision en réalité digitale
          </p>
        </div>

        {/* Grid Layout - 3 colonnes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-10">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className={`group relative bg-white border-4 border-black overflow-hidden transition-all duration-300 hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] sm:hover:shadow-[16px_16px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-2`}
              >
                {/* Top color bar */}
                <div className={`h-2 ${service.bgColor}`} />
                
                {/* Content */}
                <div className="p-4 sm:p-6 xl:p-8 relative">
                  {/* Icône + titre : côte à côte sur mobile */}
                  <div className="flex items-center gap-4 sm:block">
                  <div className={`${service.bgColor} ${service.textColor || 'text-black'} w-14 h-14 sm:w-20 sm:h-20 shrink-0 rounded-lg border-4 border-black flex items-center justify-center sm:mb-6 group-hover:scale-110 group-hover:rotate-6 transition-transform duration-300 shadow-[4px_4px_0px_0px_rgba(0,0,0,0.5)]`}>
                    <Icon className="w-7 h-7 sm:w-10 sm:h-10" />
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-xl sm:text-2xl font-black sm:mb-3 leading-tight sm:leading-tight sm:min-h-16 xl:min-h-0 xl:h-16 flex items-center">
                    {service.title}
                  </h3>
                  </div>
                  
                  {/* Description */}
                  <p className="text-sm sm:text-base font-bold text-gray-700 mt-3 sm:mt-0 mb-3 sm:mb-6 leading-relaxed sm:leading-relaxed sm:min-h-20 xl:min-h-0 xl:h-20 flex items-start">
                    {service.description}
                  </p>
                  
                  {/* Bottom accent line */}
                  <div className={`h-1 ${service.bgColor} hidden sm:block w-0 group-hover:w-full transition-all duration-300 mb-6`} />
                  
                  {/* Button */}
                  <a
                    href="#contact"
                    className={`inline-block ${service.bgColor} ${service.textColor || 'text-black'} px-4 py-2.5 sm:px-6 sm:py-3 text-sm sm:text-base font-black border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] sm:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] sm:hover:shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-x-1 hover:translate-y-1 transition-all`}
                  >
                    DEMANDER UN DEVIS →
                  </a>
                </div>
                
                {/* Hover background effect */}
                <div className={`absolute inset-0 ${service.bgColor} opacity-5 group-hover:opacity-10 transition-opacity duration-300 -z-10`} />
              </div>
            );
          })}
        </div>

        {/* Stats section */}
        <div className="grid grid-cols-3 gap-2 sm:gap-6 mt-10 sm:mt-14 md:mt-20 pt-8 sm:pt-12 md:pt-16 border-t-4 border-black">
          <div className="text-center">
            <div className="text-2xl sm:text-4xl md:text-5xl font-black text-orange-600 mb-1 sm:mb-2">3 ANS</div>
            <p className="text-[11px] sm:text-lg md:text-xl font-bold">D'EXPERTISE</p>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-4xl md:text-5xl font-black text-violet-600 mb-1 sm:mb-2">100%</div>
            <p className="text-[11px] sm:text-lg md:text-xl font-bold">SATISFACTION</p>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-4xl md:text-5xl font-black text-cyan-400 mb-1 sm:mb-2">24/7</div>
            <p className="text-[11px] sm:text-lg md:text-xl font-bold">SUPPORT</p>
          </div>
        </div>
      </div>
    </section>
  );
}
